<template>
    <div class="d-flex flex-column justify-space-between align-center">
        <v-img max-height="400" max-width="350" src="/img/nodata.png" />
        <div class="font-weight-bold text-medium-emphasis text-h4">{{ text }}</div>
    </div>
</template>

<script>
export default {
    name: 'EmptyData',
    props: {
        text: {
            type: String,
            default: 'Pase de données'
        }
    }
};
</script>
